import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeftDouble24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCaretLeftDouble24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.53 5.53a.75.75 0 1 0-1.06-1.06l-7 7-.53.53.53.53 7 7a.75.75 0 0 0 1.06-1.06L13.062 12zm-7 0a.75.75 0 1 0-1.06-1.06l-7 7-.53.53.53.53 7 7a.75.75 0 1 0 1.06-1.06L6.06 12z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeftDouble24);
